<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-alert-confirmacao-contratacao-rota
  [alertAlterarEmpresa]="showalertConfirmacaoContratacaoRota"
  (alertAlterarEmpresaFechou)="eventoConfirmacaoContratacaoRotaFechou($event)"
  [consultaSelecionada]="consultaEnviada"
  (checkPlano)="checkPlano($event)"
  [consultaAvulsa]="consultaAvulsa"
  [checkPlanoFiliais]="checkPlanoFiliais">
</app-alert-confirmacao-contratacao-rota>

<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-lg-12 mt-5">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Plano Avulso</h1>
        <p class="paragrafo mb-4 mt-4">
          Roteirizações livres.<br>
          A cobrança é gerada no primeiro pedido registrado após a consulta.<br>
          Não existe prazo contratual.
        </p>

        <div class="content mt-5 ms-3">
          <div class="form-check form-check-inline ms-2 align-items-center">
            <input
              type="radio"
              id="{{ resources?.idPlanoFaixa }}"
              class="form-check-input"
              value="{{ resources?.idPlanoFaixa }}"
              name="codigoTipoRelatorio"
              (click)="cardClick(resources)"
              (keydown)="cardClick(resources)">
            <label class="form-check-label" for="{{ resources?.idPlanoFaixa }}" aria-label="Selecionar plano"></label>
          </div>
          <div>
            <div class="card card-ajuste">
              <p class="titulo-card">Consulta Livre</p>
              <hr>
                <p class="text-card">
                  Valor da consulta<br>
                  R$ {{ resources?.VlExcentente }}
                </p>
              </div>
            </div>
          </div>

          @if (isMatriz) {
            <div class="row">
              <div class="form-check ms-3 mt-5">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="checkPlanoFiliais"
                  name="checkPedidos"
                  title="checkPlanoFiliais"
                  [(ngModel)]="checkPlanoFiliais"
                  (click)="planoFiliais()"
                  (keydown)="planoFiliais()">
                <label class="form-check-label mt-1 c-primary" for="checkPlanoFiliais">
                  Aplicar plano para filiais
                </label>
                <i
                  class="fa fa-info-circle c-black fa-1x mt-1 ms-2 icone-contratacao"
                  aria-hidden="true"
                  [popover]="myPopoverSpTrans"
                  popoverTitle="Contratação para Filiais"
                  popoverPlacement="top"
                  triggers="click"
                  [outsideClick]="true">
                </i>
                <ng-template #myPopoverSpTrans>
                  <span class="texto-tabela">
                    Se a sua empresa tem filiais cadastradas no sistema, selecione esta opção para
                    contratar o plano para todas as empresas do grupo de uma única vez.
                    <br>
                      A cobrança será aplicada a cada empresa individualmente no primeiro pedido
                      realizado após as consultas.
                    </span>
                  </ng-template>
                </div>
              </div>
            }

            <div class="row">
              <div class="col-lg-12 text-center mt-3">
                <button
                  type="button"
                  class="btn-borda-verde bnt-font btn-grande mt-5"
                  routerLink="/contratacao-rota-inteligente">
                  Fechar
                </button>

                <button
                  type="button"
                  class="btn-borda-verde btn-font-branco btn-grande-verde mt-5 ms-4"
                  [disabled]="checkPlanoStatus || !('ExclusividadesSugestaoDeRotas' | usuarioPermissao:'Incluir' | async)"
              [ngClass]="{
                disabled: checkPlanoStatus || !('ExclusividadesSugestaoDeRotas' | usuarioPermissao:'Incluir' | async)
              }"
                  (click)="AlertConfirmacaoContratacaoRota()">
                  Salvar
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>